/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_NameInputs */

const en_mk_sol_konsultan_name = /** @type {(inputs: Mk_Sol_Konsultan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`consultancies and research firms`)
};

const id_mk_sol_konsultan_name = /** @type {(inputs: Mk_Sol_Konsultan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`konsultan dan lembaga riset`)
};

/**
* | output |
* | --- |
* | "consultancies and research firms" |
*
* @param {Mk_Sol_Konsultan_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_name = /** @type {((inputs?: Mk_Sol_Konsultan_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_name(inputs)
	return en_mk_sol_konsultan_name(inputs)
});